export const zu = {
  "nav.check_booking": "Hlola Ukubhukha",
  "nav.admin": "Umphathi",
  "nav.book_now": "Bhukha Manje",
  "nav.driver": "Umshayeli",
  "hero.badge": "Ukuthuthwa Kwabafundi be-Visa J1",
  "hero.title": "Ukuthuthwa Okulula",
  "hero.subtitle": "Ukuthuthwa Kwakho Okuthembekile Kusuka Ezikhumulweni Zendiza ZaseChicago Kuya eWisconsin",
  "hero.description": "Ukuthuthwa okuphephile, okuthembekile, nokungathengi kakhulu kwabafundi be-visa J1. Bhukha ukuthathwa kwakho esikhumeleni sendiza noma uhambo lwakho lokubuya namuhla!",
  "hero.book_trip": "Bhukha Uhambo Lwakho",
  "hero.check_status": "Hlola Isimo Sokubhukha",
  "pricing.title": "Amanani Okuthuthwa",
  "pricing.subtitle": "Wonke amanani nge-USD",
  "pricing.ohare_mke": "Ukuthatha (O'Hare / Milwaukee)",
  "pricing.midway": "Ukuthatha (Midway)",
  "pricing.madison": "Madison ukuya eWisconsin Dells",
  "pricing.return": "Isaphulelo Sokubuya",
  "pricing.shared": "Uhambo Olwabelwana",
  "pricing.private": "Uhambo Lwangasese",
  "pricing.per_person": "ngomuntu",
  "pricing.after_deposit": "ngemuva kwediphozi le-$20",
  "pricing.without_deposit": "ngaphandle kwediphozi",
  "pricing.flat_rate": "inani elingaguquki",
  "pricing.per_suitcase": "Ngesikhwama ngasinye",
  "pricing.carry_on": "Isikhwama sesandla",
  "pricing.free": "MAHHALA",
  "pricing.with_shipping": "Ukubuya + thumela nathi",
  "pricing.special_deal": "Isivumelwano Esikhethekile!",
  "pricing.midway_contact": "Thintana nathi ngentengo ye-Midway (MDW)",
  "pricing.waterpark_note": "Amanani angahluka kwe-Three Bears Water Park noma ezinye izindawo.",
  "pricing.contact_us": "Thintana nathi",
  "pricing.guidelines_title": "Indlela Amanani Ethu Asebenza Ngayo",
  "pricing.guidelines_deposit": "Idiphozi le-$20 ngomuntu liqinisekisa indawo yakho. Ibhalansi esele ifuneka ngosuku lohambo.",
  "pricing.guidelines_shared": "Abagibeli aba-2 noma ngaphezulu abahamba ngosuku olufanayo besiya esikhumeleni esifanayo bathola inani lokwabelana.",
  "pricing.guidelines_solo": "Abagibeli abayedwa (umgibeli oyedwa ngalolo suku) bangakhokha inani eliphakeme kancane.",
  "pricing.guidelines_suitcase": "Isikhwama esi-1 sifakiwe mahhala kohambo lokubuya. Isikhwama ngasinye esengeziwe ngu-$5.",
  "pricing.guidelines_payment": "Samukela ukukhokha ngeKhadi, Imali Esandleni, ne-Zelle.",
  "requirements.title": "Izidingo Zokubhukha",
  "requirements.pickup": "Sihlinzeka ukuthathwa kabili ngamahora angu-24 ngaphandle uma kwazisiwe ngenye indlela. Hlela kusengaphambili!",
  "requirements.deposit": "Idiphozi le-$20 USD elingabuyiswa lidingeka ngaphambi kokufakwa eshedyulini.",
  "requirements.seamless": "Qinisekisa indawo yakho ngokwenza idiphozi lakho kusengaphambili.",
  "requirements.final_payment": "Ibhalansi esele ifuneka ngaphambi kokungena emotweni.",
  "special.title": "Indawo Ayikho Ohlwini?",
  "special.description": "Sihlinzeka uhambo lwezicelo ezikhethekile ezindaweni ezingekho emizileni yethu ejwayelekile. Thintana nathi ukuze uthole intengo ekhethekile!",
  "special.call": "Shaya Ucingo",
  "special.whatsapp": "WhatsApp Thina",
  "features.title": "Kungani Ukhetha Ukuthuthwa Okulula?",
  "features.subtitle": "Ithenjwa yizinkulungwane zabafundi be-J1 njalo ehlobo",
  "features.easy_booking": "Ukubhukha Okulula",
  "features.easy_booking_desc": "Idiphozi le-$20 USD kuphela elidingekayo. Khokha ngokudlulisela ebhange, ikhadi, i-PayPal, noma i-Zelle.",
  "features.safe": "Okuphephile Nokuthembekile",
  "features.safe_desc": "Abashayeli abangongoti, izimoto ezikhululekile, nosizo lwe-24/7 kwabafundi be-J1.",
  "features.flexible": "Ishedyuli Eguquguqukayo",
  "features.flexible_desc": "Bhukha uhambo lokufika nokubuya. Isikhwama sokuqala mahhala ekubuyeni!",
  "video.badge": "Sibheke Sisebenza",
  "video.title": "Uhambo Lwakho Luqala Lapha",
  "video.subtitle": "Bheka abafundi be-J1 beqala uhambo lwabo",
  "video.book_now": "Bhukha Uhambo Lwakho Manje",
  "booking.title": "Bhukha Uhambo Lwakho",
  "booking.step": "Isinyathelo",
  "booking.of": "kwe",
  "booking.trip_type": "Uhlobo Lohambo",
  "booking.arrival": "Ukufika (Ukuthathwa Esikhumeleni)",
  "booking.return": "Ukubuya (Ukuya Esikhumeleni)",
  "booking.ride_type": "Uhlobo Lohambo",
  "booking.shared_ride": "Uhambo Olwabelwana",
  "booking.shared_desc": "Yabelana nabanye abagibeli emzileni ofanayo",
  "booking.private_ride": "Uhambo Lwangasese",
  "booking.private_desc": "Imoto ekhethekile ngeyakho kuphela",
  "booking.pickup_location": "Isikhumulelo Sokuthathwa",
  "booking.select_airport": "Khetha Isikhumulelo",
  "booking.travel_date": "Usuku Lohambo",
  "booking.travel_time": "Isikhathi Sokulindela Ukufika",
  "booking.departure_time": "Isikhathi Sokuhamba",
  "booking.flight_number": "Inombolo Yendiza",
  "booking.airline": "Inkampani Yezindiza",
  "booking.terminal": "Itheminali Yokufika",
  "booking.full_name": "Igama Eliphelele",
  "booking.whatsapp": "Inombolo ye-WhatsApp",
  "booking.email": "Ikheli Le-imeyili",
  "booking.housing": "Indlu Yokuhlala",
  "booking.select_housing": "Khetha Indlu",
  "booking.custom_address": "Faka Ikheli Elikhethekile",
  "booking.num_passengers": "Inani Labagibeli",
  "booking.suitcases": "Izikhwama Eziphelele",
  "booking.shipping": "Usebenzisa i-T&M Courier?",
  "booking.payment": "Indlela Yokukhokha",
  "booking.referral": "Ikhodi Yesithunywa",
  "booking.next": "Okulandelayo",
  "booking.previous": "Okwangaphambili",
  "booking.submit": "Qedela Ukubhukha",
  "booking.processing": "Kuyasebenza...",
  "booking.start_over": "Qala Kabusha",
  "booking.first_time": "Uhambo Lokuqala",
  "booking.returning": "Umthengi Obuyayo",
  "booking.confirmation_number": "Inombolo Yokuqinisekisa",
  "pricing_summary.title": "Isifingqo Samanani",
  "pricing_summary.trip_price": "Inani Lohambo",
  "pricing_summary.luggage_fee": "Imali Yezikhwama",
  "pricing_summary.deposit": "Idiphozi",
  "pricing_summary.per_person": "ngomuntu",
  "pricing_summary.discount": "Isaphulelo Sesithunywa",
  "pricing_summary.total_now": "Isamba Esidingekayo Manje",
  "pricing_summary.balance": "Ibhalansi Esele",
  "success.title": "Ukubhukha Kuqinisekisiwe!",
  "success.confirmation": "Inombolo Yokuqinisekisa",
  "success.details": "Imininingwane Yokubhukha",
  "success.whatsapp_optin": "Thola izibuyekezo nge-WhatsApp",
  "success.home": "Buyela Ekhaya",
  "driver.title": "Idashbhodi Yomshayeli",
  "driver.login": "Ukungena Komshayeli",
  "driver.phone": "Inombolo Yocingo",
  "driver.pin": "Ikhodi ye-PIN",
  "driver.sign_in": "Ngena",
  "driver.trips_today": "Uhambo Lwanamuhla",
  "driver.upcoming": "Uhambo Oluzayo",
  "driver.passengers": "abagibeli",
  "driver.suitcases": "izikhwama",
  "driver.navigate": "Hamba Ukuya Ekuthathweni",
  "driver.contact": "Thinta Umgibeli",
  "driver.complete": "Qedela Uhambo",
  "driver.logout": "Phuma",
  "driver.no_trips": "Akukho hambo oluhleliwe",
  "common.loading": "Kuyalayisha...",
  "common.error": "Kukhona okungahambanga kahle",
  "common.save": "Londoloza",
  "common.cancel": "Khansela",
  "common.close": "Vala",
  "common.details": "Imininingwane",
  "common.status": "Isimo",
  "common.date": "Usuku",
  "common.time": "Isikhathi",
  "common.price": "Inani",
  "common.passenger": "Umgibeli",
  "common.passengers": "Abagibeli",
};
